module.exports = __webpack_public_path__ + "ecad55d809fbe57983ff84acfcd93ed3.png";